"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outcome = void 0;
const flatbuffers = require("flatbuffers");
const outcome_type_js_1 = require("../../sportsbook/actual/outcome-type.js");
class Outcome {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOutcome(bb, obj) {
        return (obj || new Outcome()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOutcome(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Outcome()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    odds() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    state() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    active() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : true;
    }
    type() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : outcome_type_js_1.OutcomeType.predefined;
    }
    team() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    static startOutcome(builder) {
        builder.startObject(6);
    }
    static addId(builder, id) {
        builder.addFieldInt32(0, id, 0);
    }
    static addOdds(builder, odds) {
        builder.addFieldInt32(1, odds, 0);
    }
    static addState(builder, state) {
        builder.addFieldInt8(2, state, 1);
    }
    static addActive(builder, active) {
        builder.addFieldInt8(3, +active, +true);
    }
    static addType(builder, type) {
        builder.addFieldInt8(4, type, outcome_type_js_1.OutcomeType.predefined);
    }
    static addTeam(builder, team) {
        builder.addFieldInt16(5, team, 0);
    }
    static endOutcome(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOutcome(builder, id, odds, state, active, type, team) {
        Outcome.startOutcome(builder);
        Outcome.addId(builder, id);
        Outcome.addOdds(builder, odds);
        Outcome.addState(builder, state);
        Outcome.addActive(builder, active);
        Outcome.addType(builder, type);
        Outcome.addTeam(builder, team);
        return Outcome.endOutcome(builder);
    }
}
exports.Outcome = Outcome;
